<div id="rateAvailabilityReportComponent">
  <app-confirm-dialog [openModal]="showModal"></app-confirm-dialog>
    <div class="gridHeader">
        <span class="gridTitle">Reports</span>
    </div>
    <app-alert></app-alert>
    <div class="k-widget k-tabstrip k-floatwrap k-tabstrip-top k-header" id="rateAvailabilitySubHeader">
        <ul class="k-reset k-tabstrip-items">
            <li [class]="('k-item k-state-default' + (this.activeTab=='RateAvailabilityReports'?' k-state-active':''))" id="RateAvailabilityReportsListItem" (click)="switchTab($event)">
                <a class="k-link" href="#">Rate Availability Reports</a>
            </li>
            <li [class]="('k-item k-state-default' + (this.activeTab=='CustomRateAvailabilityReports'?' k-state-active':''))" id="CustomRateAvailabilityReportsListItem" (click)="switchTab($event)">
                <a class="k-link" href="#">Custom Rate Availability Reports</a>
            </li>
        </ul>
    </div>
    <div class="reportsContent" *ngIf="this.activeTab=='RateAvailabilityReports'">
        <kendo-grid
        [data]="linkList"
        class="linkListGrid"
        [scrollable]="'scrollable'">
            <kendo-grid-column title="Title" [width]="150" field="title">
                <ng-template kendoGridHeaderTemplate let-column>
                    {{column.title}}
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <a *ngIf="dataItem.routerLink" [routerLink]="[dataItem.href, dataItem.paramObject]">{{dataItem.title}}</a>
                    <a *ngIf="!dataItem.routerLink"(click)="DownloadRVReports(dataItem.param)"  class="reportlink" >{{dataItem.title}}</a>
<div *ngIf="dataItem.param == this.currentReport">
  <span class="message"  [innerText]="this.longRunningRAWMessage" ></span>
</div>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
        <app-spinner [isBusy]="disableRequests"></app-spinner>

    </div>
    <div class="customReportsContentContainer" *ngIf="this.activeTab=='CustomRateAvailabilityReports'">
        <table class="customReportsContent">
            <tr>
            <td class="reportConfigurationList">
             <app-configurable-link-list
              (linkClickedOutput)="changeSelectedReportConfig($event)"
              (deleteClickedOutput)="deleteReportConfiguration($event)"
              [list]="this.availableReportConfigurations">
              </app-configurable-link-list>
            </td>
            <td class="reportConfigurationForm">
              <div class="containingRow reportLabelsDescriptionsContainerParent">
                <span class="reportButtonsContainer">
                  <button (click)="createNewReportConfiguration()" class="slds-button cvt-secondary">
                    <span class="slds-truncate">New</span>
                  </button>
                  <button class="slds-button cvt-primary" (click)="saveReport()">
                    <span class="slds-truncate">Save</span>
                  </button>
                  <button class="slds-button cvt-tertiary"  (click)="ExportToExcel()">
                    <span class="slds-truncate">Export To Excel</span>
                  </button>
                </span>
                <span>
                    <span class="reportLabelDescriptionContainer">
                      <span class="marginRight">Report Title    <label class="asterix">*</label></span>
                      <span *ngIf="selectedReportConfig" class="marginMoreRight">
                        <input [(ngModel)]="selectedReportConfig.textContent" type="text"/>
                      </span>
                    </span>
                    <span class="reportLabelDescriptionContainer">
                      <span class="marginRight">GDS</span>
                      <span class="marginMoreRight">
                        <kendo-dropdownlist
                        [data]="gdsCodeList"

                        *ngIf="selectedReportConfig"
                        [(ngModel)]="selectedReportConfig.gds"
                        (ngModelChange)="changeGDSCode()"
                        [textField]="'text'"
                        [valueField]="'value'"
                        [valuePrimitive]="false">
                          <ng-template kendoDropDownListValueTemplate let-dataItem>
                            <span *ngIf="selectedReportConfig && selectedReportConfig.gds" [innerText]="selectedReportConfig.gds.text"></span>
                          </ng-template>
                          <ng-template kendoDropDownListItemTemplate let-dataItem>{{dataItem.text}}</ng-template>
                        </kendo-dropdownlist>
                      </span>
                    </span>
                    <span class="reportLabelDescriptionContainer">
                      <span class="marginRight">Report Description    <label class="asterix">*</label></span>
                      <span *ngIf="selectedReportConfig" class="marginMoreRight">
                        <input [(ngModel)]="selectedReportConfig.Description" type="text" />
                      </span>
                    </span>
                </span>
              </div>
              <div id="gridsContainer">
                <div class="containingRow">
                  <div class="reportDialog reportDialogHalfWide">
                    <div class="reportDialogHeader gridTitle">Output Field Customization</div>
                    <kendo-grid
                    *ngIf="selectedReportConfig"
                    [data]="selectedReportConfig.outputFieldCustomizationData"
                    class="outputFieldCustomizationGrid">
                      <kendo-grid-column title="" [width]="40" field="active">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <div class="checkboxContainer" (click)="toggleCheckbox(dataItem)">
                            <span *ngIf="dataItem && dataItem.active" class="cvt-icon-check grid-status-icons"></span>
                          </div>
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column title="Field Name" [width]="130" field="id">
                      </kendo-grid-column>
                      <kendo-grid-column title="Report Wording Override" field="override">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <input type="text" [(ngModel)]="dataItem.override"/>
                        </ng-template>
                      </kendo-grid-column>
                    </kendo-grid>
                  </div>
                  <div class="reportDialog reportDialogHalfWide" style="float:right; padding-bottom:5px">
                    <div class="reportDialogHeader gridTitle">Report Title Settings</div>
                    <kendo-grid
                    *ngIf="selectedReportConfig"
                    [data]="selectedReportConfig.reportTitleSettings"
                    class="reportTitleSettingsGrid">
                      <kendo-grid-column title="Status" field="id">
                      </kendo-grid-column>
                      <kendo-grid-column title="Display Text" [width]="160" field="override">
                          <ng-template kendoGridCellTemplate let-dataItem>
                              <input type="text" [(ngModel)]="dataItem.override" class="normalTextBox"/>
                          </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column title="Abr." field="overrideAbr">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            <input type="text" [(ngModel)]="dataItem.overrideAbr" class="shortTextBox"/>
                          </ng-template>
                      </kendo-grid-column>
                    </kendo-grid>
                  </div>
                </div>
                <div class="containingRow" style="clear:both">
                  <kendo-grid
                  [data]="reportData"
                  class="reportDataViewGrid"
                  *ngIf="selectedReportConfig && selectedReportConfig.outputFieldCustomizationData && selectedReportConfig.outputFieldCustomizationData.data"
                  [skip]="state.skip"
                  [sort]="state.sort"
                  [sortable]="true"
                  [scrollable]="'scrollable'">
                    <ng-container
                      *ngFor="let property of selectedReportConfig.outputFieldCustomizationData.data">
                      <kendo-grid-column
                        [width]="200"
                        *ngIf="property.active && property.javascriptId && !property.javascriptId.match('^Season\\d')"
                        [title]="property.override"
                        [field]="property.javascriptId">
                      </kendo-grid-column>
                      <kendo-grid-column
                        [width]="200"
                        *ngIf="property.active && property.javascriptId=='Season1'"
                        [title]="property.override"
                        [field]="property.javascriptId">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{dataItem.Season1StartDateDisplay}}
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column
                        [width]="200"
                        *ngIf="property.active && property.javascriptId=='Season1ExpectedPrice'"
                        [title]="property.override"
                        [field]="property.javascriptId">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <span [innerText]='dataItem.Season1ExpectedPrice | price:  dataItem.Season1Dynamic : dataItem.Season1Ceiling '>{{dataItem.Season4ExpectedPrice}}</span>
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column
                        [width]="200"
                        *ngIf="property.active && property.javascriptId=='Season2'"
                        [title]="property.override"
                        [field]="property.javascriptId">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{dataItem.Season2StartDateDisplay}}
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column
                        [width]="200"
                        *ngIf="property.active && property.javascriptId=='Season2ExpectedPrice'"
                        [title]="property.override"
                        [field]="property.javascriptId">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <span [innerText]='dataItem.Season2ExpectedPrice | price:  dataItem.Season2Dynamic : dataItem.Season2Ceiling '>{{dataItem.Season4ExpectedPrice}}</span>
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column
                        [width]="200"
                        *ngIf="property.active && property.javascriptId=='Season3'"
                        [title]="property.override"
                        [field]="property.javascriptId">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{dataItem.Season3StartDateDisplay}}
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column
                        [width]="200"
                        *ngIf="property.active && property.javascriptId=='Season3ExpectedPrice'"
                        [title]="property.override"
                        [field]="property.javascriptId">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <span [innerText]='dataItem.Season3ExpectedPrice | price:  dataItem.Season3Dynamic : dataItem.Season3Ceiling '>{{dataItem.Season4ExpectedPrice}}</span>
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column
                        [width]="200"
                        *ngIf="property.active && property.javascriptId=='Season4'"
                        [title]="property.override"
                        [field]="property.javascriptId">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{dataItem.Season4StartDateDisplay}}
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column
                        [width]="200"
                        *ngIf="property.active && property.javascriptId=='Season4ExpectedPrice'"
                        [title]="property.override"
                        [field]="property.javascriptId">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <span [innerText]='dataItem.Season4ExpectedPrice | price:  dataItem.Season4Dynamic : dataItem.Season4Ceiling '>{{dataItem.Season4ExpectedPrice}}</span>
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column
                        [width]="200"
                        *ngIf="property.active && property.javascriptId=='Season5'"
                        [title]="property.override"
                        [field]="property.javascriptId">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{dataItem.Season5StartDateDisplay}}
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column
                        [width]="200"
                        *ngIf="property.active && property.javascriptId=='Season5ExpectedPrice'"
                        [title]="property.override"
                        [field]="property.javascriptId">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <span [innerText]='dataItem.Season5ExpectedPrice | price:  dataItem.Season5Dynamic : dataItem.Season5Ceiling '>{{dataItem.Season4ExpectedPrice}}</span>
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column
                        [width]="200"
                        *ngIf="property.active && property.javascriptId=='Season6'"
                        [title]="property.override"
                        [field]="property.javascriptId">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{dataItem.Season6StartDateDisplay}}
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column
                        [width]="200"
                        *ngIf="property.active && property.javascriptId=='Season6ExpectedPrice'"
                        [title]="property.override"
                        [field]="property.javascriptId">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <span [innerText]='dataItem.Season6ExpectedPrice | price:  dataItem.Season6Dynamic : dataItem.Season6Ceiling '>{{dataItem.Season4ExpectedPrice}}</span>
                        </ng-template>
                      </kendo-grid-column>
                    </ng-container>
                    <ng-container
                      *ngFor="let data of numSelectedDatesArray; let i = index">
                      <kendo-grid-column
                        [width]="200"
                        [title]="data.SelectedDate"
                        [field]="'SelectedDateDisplay' + i + 'ExpectedPrice'">
                      </kendo-grid-column>
                      <kendo-grid-column
                        [width]="200"
                        [title]="data.SelectedDate + ' Status'"
                        [field]="'SelectedDateDisplay' + i + 'Status'">
                      </kendo-grid-column>
                    </ng-container>
                  </kendo-grid>
                </div>
              </div>
            </td>
          </tr>
        </table>
    </div>
</div>
